import { client } from "./index";

// Product categories of one website (/api/admin/sites/:siteId/categories)
export const getCategories = (siteId) => client.get(`/admin/sites/${siteId}/categories`);
export const createCategory = (siteId, payload) => client.post(`/admin/sites/${siteId}/categories`, payload);
export const updateCategory = (siteId, categoryId, payload) => client.put(`/admin/sites/${siteId}/categories/${categoryId}`, payload);
export const deleteCategory = (siteId, categoryId) => client.delete(`/admin/sites/${siteId}/categories/${categoryId}`);
